import React, { useEffect, useState } from "react";
import FullPageLoader from "./Components/FullPageLoader/FullPageLoader";
import "./App.less";
import { Redirect, useLocation, Route, Switch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LayoutWrapper from "./Layout/LayoutWrapper";
import { routes } from "./routes/routes";
import CustomRoute from "./routes/CustomRoute";
import { ALL_HEADER_CONSTANTS } from "./HeaderConstants";
import { ROLES } from "./HeaderConstants";
import { setMenus, toggleLoading } from "./Redux/Slices/MenuSlice";

const App = () => {
  const auth = useSelector((state) => state?.auth?.user);
  const menus = auth
    ? ALL_HEADER_CONSTANTS[ROLES[auth.role]]
    : ALL_HEADER_CONSTANTS[ROLES["default"]];
  const dispatch = useDispatch();
  const [updatedRoutes, setUpdatedRoutes] = useState([]);

  const setFilteredRoutes = () => {
    const filteredRoutes = routes.filter((item) => {
      dispatch(toggleLoading(true));
      if (!item.access) {
        return item;
      }
      if ((item.access && auth) || !item.access) {
        if (item.access?.includes(auth.role)) {
          return item;
        }
      }
    });
    menus.length > 0 && dispatch(setMenus(menus));
    setUpdatedRoutes([...filteredRoutes]);
  };

  useEffect(() => {
    setFilteredRoutes();
  }, [auth]);

  return (
    <React.Suspense fallback={<FullPageLoader />}>
      <Switch>
        <LayoutWrapper>
          {updatedRoutes.length > 0 &&
            updatedRoutes.map((item) => {
              return (
                <CustomRoute
                  key={item.link}
                  exact
                  title={item.name}
                  path={item.link}
                  component={item.component}
                />
              );
            })}
          {/* <Route path="*" component={<Redirect to="/" />} /> */}
        </LayoutWrapper>
      </Switch>
    </React.Suspense>
  );
};

export default App;
